import { connect } from 'react-redux';

import MembershipToggle from '../components/MembershipToggle';
import {
  changeOrderMembership,
  removeCommitmentRewardLineItemsAndDisableOrderMembership,
} from '../actions';

export const mapStateToProps = state => ({
  isMembershipOrder: state.currentOrder.membership_order,
  hasSubscriptionCommitment: state.currentOrder.has_subscription_commitment,
});

export const mapDispatchToProps = dispatch => ({
  changeOrderMembership: (value, eventLocation) =>
    dispatch(changeOrderMembership(value, eventLocation)),
  removeCommitmentRewardLineItemsAndDisableOrderMembership: () =>
    dispatch(removeCommitmentRewardLineItemsAndDisableOrderMembership()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MembershipToggle);
